export const CONSENT_KEY = "arcondes_consent_v1";
export const CONSENT_UPDATED_EVENT = "arcondes:consent-updated";
export const CONSENT_OPEN_PREFS_EVENT = "arcondes:consent-open-prefs";

export function openConsentPreferences() {
  window.dispatchEvent(new CustomEvent(CONSENT_OPEN_PREFS_EVENT));
}

export interface ConsentState {
  version: 1;
  timestamp: number;
  necessary: true;
  analytics: boolean;
  marketing: boolean;
}

type GtagFn = (...args: unknown[]) => void;
type FbqFn = (...args: unknown[]) => void;

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: GtagFn;
    fbq?: FbqFn;
  }
}

function gtag(...args: unknown[]) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(args);
}

export function readConsent(): ConsentState | null {
  try {
    const raw = localStorage.getItem(CONSENT_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as ConsentState;
    if (parsed.version !== 1) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function saveConsent(state: Omit<ConsentState, "version" | "timestamp" | "necessary">) {
  const full: ConsentState = {
    version: 1,
    timestamp: Date.now(),
    necessary: true,
    analytics: state.analytics,
    marketing: state.marketing,
  };
  localStorage.setItem(CONSENT_KEY, JSON.stringify(full));
  applyConsent(full);
  window.dispatchEvent(new CustomEvent(CONSENT_UPDATED_EVENT, { detail: full }));
}

export function applyConsent(state: ConsentState) {
  const analytics = state.analytics ? "granted" : "denied";
  const marketing = state.marketing ? "granted" : "denied";
  gtag("consent", "update", {
    ad_storage: marketing,
    ad_user_data: marketing,
    ad_personalization: marketing,
    analytics_storage: analytics,
  });
  if (typeof window.fbq === "function") {
    window.fbq("consent", state.marketing ? "grant" : "revoke");
  }
}

export function acceptAll() {
  saveConsent({ analytics: true, marketing: true });
}

export function rejectAll() {
  saveConsent({ analytics: false, marketing: false });
}
